import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./avenir-next/a0f4c2f9-8a42-4786-ad00-fce42b57b148.ttf%22,%22variable%22:%22--font-avenir-next-demi%22}],%22variableName%22:%22avenirNextDemi%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'avenirNextDemi', 'avenirNextDemi Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
